<template>
  <button
    tabindex="-1"
    type="button"
    :class="`arrow-button arrow-button-${direction}`"
    @click.prevent="$emit('click')"
    :title="title"
  >
    <FaIcon :icon="`chevron-${direction}`" class="arrow-button-icon" />
    <slot />
  </button>
</template>

<script>
import FaIcon from './ui/FaIcon'

export default {
  name: 'ArrowButton',
  components: { FaIcon },
  props: {
    direction: {
      type: String,
      required: true,
      validator(value) {
        return ['left', 'right'].includes(value)
      },
    },
    title: String,
  },
}
</script>

<style lang="scss" scoped>
@keyframes arrow-button-bounce-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-10%);
  }
}

@keyframes arrow-button-bounce-right {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(10%);
  }
}

.arrow-button {
  $size: 4em;
  --arrow-button-size: 4em;

  position: relative;
  display: inline-block;
  box-sizing: content-box;
  width: var(--arrow-button-size, #{$size});
  height: var(--arrow-button-size, #{$size});
  padding: 1em;
  overflow: hidden;
  vertical-align: middle;
  color: $gray;
  background: transparent;
  cursor: pointer;
  border: none;
  border-radius: 100%;
  box-shadow: none;
  outline: 0;
  transition: opacity 0.2s ease-out;

  @media (hover: hover) {
    &:not([disabled]):hover {
      .arrow-button-icon {
        animation: 0.5s infinite alternate arrow-button-bounce-left;
      }

      &.arrow-button-right {
        .arrow-button-icon {
          animation-name: arrow-button-bounce-right;
        }
      }
    }
  }

  &:active {
    transform: scale(0.95);
  }

  &[disabled] {
    opacity: 0;
    transform: scale(0.5);
    transition: all 0.5s ease-out;
  }

  > svg {
    display: block;
    width: 100%;
    height: 100%;

    // Make sure all pointer events originate from the button and not from random paths in the SVG file
    pointer-events: none;
  }
}
</style>
